(function () {
  var widget = document.querySelector('.yotpo-widget-instance[data-yotpo-section-id="product"]');
  if (!widget) return;

  var wrapper = widget.closest('.shopify-app-block') || widget;
  var zeroReviewsPattern = /^\(?0\)?\s*reviews?\b/i;

  function hideIfNoReviews() {
    var text = widget.textContent.trim();
    if (text === '') return false;

    if (zeroReviewsPattern.test(text)) {
      wrapper.style.display = 'none';
    }
    return true;
  }

  if (hideIfNoReviews()) return;

  var observer = new MutationObserver(function () {
    if (hideIfNoReviews()) observer.disconnect();
  });

  observer.observe(widget, { childList: true, subtree: true, characterData: true });

  setTimeout(function () {
    observer.disconnect();
  }, 8000);
})();
